export default __webpack_public_path__ + "static/media/dophin.d1f526a1.svg";